import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Dashboard from "components/Template/Dashboard";
import { createTerm, listTerms } from "services/term";
import Loading from "components/Loading";
import TextEditor from "components/Terms/TextEditor";
import TermsVersion from "components/Terms/Version";
import Header from "components/Terms/Header";

type Props = {};

const TermsConditionsStore: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [term, setTerm] = useState<any>();

  const [convertedContent, setConvertedContent] = useState("");

  const termActiveData = async (id: string) => {
    try {
      setLoading(true);
      const { data } = await listTerms();
      setTerm(data);
    } catch (_) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (history.location.pathname.split("/")[2]) {
      termActiveData(history.location.pathname.split("/")[2]);
    }
  }, [history]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await createTerm({
        title: "Term 1",
        content: convertedContent,
      });
      history.push("/terms-conditions");
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dashboard
      title={"Terms and Conditions"}
      breadcrumb={[]}
      subInfo={""}
      children={
        <Fragment>
          <Loading loading={loading} />
          {term && (
            <>
              <Header />
              <TextEditor
                content={term.content}
                setConvertedContent={setConvertedContent}
              />
              <TermsVersion
                version={term.version}
                handleSubmit={handleSubmit}
              />
            </>
          )}
        </Fragment>
      }
    />
  );
};

export default TermsConditionsStore;
